<template>
  <div
    v-if="isOpen"
    class="rotation-group-popup"
  >
    <div class="popup">
      <div class="head">
        <span class="name">{{ $t(`domainManagement.popup.rotationGroups`) }}</span>
        <UiIcon
          :size="20"
          class="close"
          name="times"
          @click="close"
        />
      </div>
      <div class="form full-width">
        <UiSelectElement
          v-model="platform_service_rotation_group_id"
          :label="$t(`domainManagement.popup.form.platform_service_rotation_group_id.label`)"
          :list="selectData"
          filterable
        />
      </div>
      <div class="foot">
        <UiButton
          type="negative"
          class="cancel-button"
          icon="times"
          size="big"
          @click="close"
        >
          {{ $t(`domainManagement.popup.cancel`) }}
        </UiButton>
        <UiButton
          filled
          icon="check"
          size="big"
          :disabled="!platform_service_rotation_group_id"
          @click="save"
        >
          {{ $t(`affiliates.offer_popup.Add`) }}
        </UiButton>
      </div>
    </div>
    <div class="wrapper" />
  </div>
</template>

<script>
export default {
  name: 'AffiliateRotationGroupsPopup',

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },

    initalData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  emits: ['save', 'close'],

  data() {
    return {
      platform_service_rotation_group_id: null,
      platformServiceRotationGroups: [],
    };
  },

  computed: {
    selectData() {
      const arrayAlreadyФddedКotations = this.initalData.map((el) => el.id);
      return this.platformServiceRotationGroups.filter(
        (elem) => !arrayAlreadyФddedКotations.includes(elem.id),
      );
    },
  },

  mounted() {
    window.addEventListener('keyup', this.keyupHandler);
  },

  unmounted() {
    window.removeEventListener('keyup', this.keyupHandler);
  },

  async created() {
    await this.fetchRotationGroups();
  },

  methods: {
    async fetchRotationGroups() {
      const { data: { payload } } = await this.$api.getRotationGroups();

      const arrayAlreadyФddedКotations = this.initalData.map((el) => el.id);
      this.platformServiceRotationGroups = payload.filter(
        (elem) => !arrayAlreadyФddedКotations.includes(elem.id),
      );
    },

    close() {
      this.resetForm();
      this.$emit('close');
    },

    save() {
      const data = {
        platform_service_rotation_group_id: this.platform_service_rotation_group_id,
      };

      this.$emit('save', data);

      this.close();
    },

    keyupHandler(e) {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    },

    resetForm() {
      this.platform_service_rotation_group_id = null;
    },
  },
};
</script>
